(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSSectorDetailController', SSSectorDetailController);

    SSSectorDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SSSector'];

    function SSSectorDetailController($scope, $rootScope, $stateParams, previousState, entity, SSSector) {
        var vm = this;

        vm.sSSector = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:sSSectorUpdate', function(event, result) {
            vm.sSSector = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
